import React from 'react'

const Footer = () => (<footer className="footer">
  <p>© 2020 Joint Force Leadership</p>
</footer>)

export default Footer
